import './common/api/project-api'
import './common/utils/localisation'
// Any IE polyfills etc
import './common/utils/polyfill-common'
